import React from 'react';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import { CreditCard, Receipt, Calendar } from 'lucide-react';

const BillingSettings = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold text-text-dark dark:text-dark-text mb-2">Billing</h2>
        <p className="text-text-gray dark:text-dark-text-secondary">
          Manage your subscription and payment methods
        </p>
      </div>

      {/* Current Plan Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <CreditCard className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-dark dark:text-dark-text">Current Plan</h3>
        </div>

        <div className="max-w-2xl p-6 border border-gray-200 dark:border-[#2e2e2d] rounded-lg bg-gradient-to-br from-white to-gray-50 dark:from-dark-card dark:to-dark-card/50">
          <div className="flex items-start justify-between">
            <div>
              <h4 className="text-2xl font-bold text-text-dark dark:text-dark-text">Free Plan</h4>
              <p className="text-text-gray dark:text-dark-text-secondary mt-1">
                Perfect for getting started
              </p>
              <div className="mt-4 space-y-2">
                <div className="flex items-center gap-2 text-sm">
                  <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
                  <span className="text-text-gray dark:text-dark-text-secondary">Up to 10 skills</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
                  <span className="text-text-gray dark:text-dark-text-secondary">100 API calls per month</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <div className="h-1.5 w-1.5 rounded-full bg-primary"></div>
                  <span className="text-text-gray dark:text-dark-text-secondary">Community support</span>
                </div>
              </div>
            </div>
            <div className="text-right">
              <p className="text-3xl font-bold text-text-dark dark:text-dark-text">$0</p>
              <p className="text-sm text-text-gray dark:text-dark-text-secondary">per month</p>
            </div>
          </div>
          <Button variant="gradient" className="mt-6 w-full sm:w-auto">
            Upgrade Plan
          </Button>
        </div>
      </div>

      <Separator />

      {/* Payment Method Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <CreditCard className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-dark dark:text-dark-text">Payment Method</h3>
        </div>

        <div className="max-w-2xl p-6 border border-dashed border-gray-300 dark:border-[#2e2e2d] rounded-lg text-center">
          <p className="text-text-gray dark:text-dark-text-secondary mb-4">
            No payment method on file
          </p>
          <Button variant="outline">
            <CreditCard className="h-4 w-4 mr-2" />
            Add Payment Method
          </Button>
        </div>
      </div>

      <Separator />

      {/* Billing History Section */}
      <div className="space-y-4">
        <div className="flex items-center gap-2">
          <Receipt className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-semibold text-text-dark dark:text-dark-text">Billing History</h3>
        </div>

        <div className="max-w-2xl p-12 border border-gray-200 dark:border-[#2e2e2d] rounded-lg text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 dark:bg-dark-bg-tertiary mb-4">
            <Calendar className="h-8 w-8 text-gray-400 dark:text-gray-600" />
          </div>
          <p className="text-text-dark dark:text-dark-text font-medium mb-1">
            No billing history yet
          </p>
          <p className="text-sm text-text-gray dark:text-dark-text-secondary">
            Your invoices and payment history will appear here
          </p>
        </div>
      </div>
    </div>
  );
};

export default BillingSettings;
